import { FC } from 'react';
import { Box, styled } from '@mui/material';
import classNames from 'classnames';

import { AddOrRemoveButton, AddOrRemoveButtonProps } from '@components/common/AddOrRemoveButton';

const StyledAddItemChipButton = styled(AddOrRemoveButton)`
  .react-draggable-dragging & {
    display: none;
  }
`;

type AddItemButtonProps = Omit<AddOrRemoveButtonProps, 'avatar'>;

const AddItemButton: FC<AddItemButtonProps> = ({ className, ...rest }) => (
  <Box alignItems='center' display='flex' justifyContent='center'>
    <StyledAddItemChipButton
      className={classNames(className, 'hide-on-drag')}
      icon='add'
      {...rest}
    />
  </Box>
);

export default AddItemButton;
